import { createI18n } from "vue-i18n";
import ptBR from "@/locales/pt-BR.json";
import enUS from "@/locales/en-US.json";

const LS_KEY = "luckydesk.locale";

export type LocaleCode = "pt-BR" | "en-US";

export function detectLocale(): LocaleCode {
  const saved = localStorage.getItem(LS_KEY) as LocaleCode | null;
  if (saved === "pt-BR" || saved === "en-US") return saved;
  // Default pt-BR (per product spec) even if browser is en.
  return "pt-BR";
}

export function persistLocale(loc: LocaleCode) {
  localStorage.setItem(LS_KEY, loc);
}

export const i18n = createI18n({
  legacy: false,
  locale: detectLocale(),
  fallbackLocale: "pt-BR",
  messages: { "pt-BR": ptBR, "en-US": enUS },
});
